import { BooleanInput, coerceBooleanProperty } from '@angular/cdk/coercion';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { SgTextVariant } from '../sg-text/sg-text.component';

export type SgLabelTextVariant =
  | 'neutral'
  | 'magenta'
  | 'turquoise'
  | 'sky-blue'
  | 'dusk'
  | 'purple'
  | 'navy'
  | 'royal';
export type SgLabelTextSize = 'small' | 'medium' | 'large';

const TEXT_VARIANT_MAP: { [key: string]: SgTextVariant } = {
  small: 'sg-label-small-regular',
  medium: 'sg-body-medium-bold',
  large: 'sg-heading-large-bold',
};
@Component({
  selector: 'sg-label',
  templateUrl: './sg-label.component.html',
  styleUrls: ['./sg-label.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class SgLabelComponent {
  @Input() text = '';
  @Input() icon = '';
  @Input('inverted') set _inverted(value: BooleanInput) {
    this.inverted = coerceBooleanProperty(value);
  }
  @Input() variant: SgLabelTextVariant = 'neutral';
  @Input() size: SgLabelTextSize = 'medium';
  @Input('wrapText') set _wrapText(value: BooleanInput) {
    this.wrapText = coerceBooleanProperty(value);
  }

  get textVariant(): SgTextVariant {
    return TEXT_VARIANT_MAP[this.size];
  }

  public inverted: boolean = false;
  public wrapText: boolean = false;
}
